import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import AlbumItem from './albumItem'

import Button from '../../ui/button'
import UploadPhotoPopup from '../popups/uploadPhotoPopup'
import WithPhotoSlider, { WithPhotoSliderProps } from '../../../hoc/withPhotoSlider'

import { AlbumType, PhotoType, Profile } from '../../../store/commonTypes'

import paths from '../../../paths'
import { photoUploadErrorClean } from '../../../store/member/memberSlice'
import isEmpty from 'lodash/isEmpty'
import s from './materialPreview.module.sass'
import ButtonLink from '../../ui/buttonLink'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import { RootState } from '../../../store/rootReducer'

interface Props extends WithPhotoSliderProps {
    self?: boolean
    user: Profile
    album: AlbumType
}

const AlbumPreview: React.FunctionComponent<Props> = ({ self, album, user, openPhoto }: Props) => {
    const [t] = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()

    const [showPopup, setShowPopup] = useState(false)
    const isAgeVerified = useSelector((state: RootState) => state.common.isAgeVerified)
    const emptyAlbum = isEmpty(album.list)

    return (
        <div className={s['materialsPreview']}>
            <div className={s['materialsPreview__row']}>
                <div className={s['materialsPreview__row']}>
                    <div className={s['materialsPreview__title']}>{self ? t('My album') : t('Public album')}</div>
                    <div data-testid={'albumCounter'} className={s['materialsPreview__counter']}>
                        {!emptyAlbum && album.list.length + (self ? t('of 20') : '')}
                    </div>
                </div>
                {self && <Button label={t('Upload photo')} small onClick={() => setShowPopup(true)} />}
            </div>
            {emptyAlbum ? (
                self ? (
                    <div className={s['materialsPreview__emptyPlaceholder']}>
                        <div className={s['header']}>{t('You don&apos;t have any photos')}</div>
                        <div className={s['description']}>{t('But you always can upload some')}</div>
                    </div>
                ) : (
                    <div className={s['materialsPreview__emptyPlaceholder']}>
                        <div className={s['header']}>
                            {user.nick} {t('doesn&apos;t have any photos')}
                        </div>
                    </div>
                )
            ) : (
                <div className={s['materialsPreview__list']}>
                    {album.list.map((photo: PhotoType) => (
                        <AlbumItem photo={photo} isAgeVerified={isAgeVerified} openPhoto={openPhoto} key={photo.id} />
                    ))}
                </div>
            )}
            {!emptyAlbum && (
                <ButtonLink
                    secondary
                    label={self ? t('All my photos') : t('All photos')}
                    linkUrl={
                        self
                            ? createLocalizedPath(paths.myAlbum.path)
                            : createLocalizedPath(paths.profileAlbum.toPath({ nick: user.nick }))
                    }
                />
            )}

            {showPopup && (
                <UploadPhotoPopup
                    onClose={() => {
                        setShowPopup(false)
                        dispatch(photoUploadErrorClean())
                    }}
                />
            )}
        </div>
    )
}

export default WithPhotoSlider()(AlbumPreview)
